import {
  GET_PACKAGES_FAILURE,
  GET_PACKAGES_REQUEST,
  GET_PACKAGES_SUCCESS,
  GET_PACKAGES_TIMEOUT
} from '../constants/ActionTypes';
import { dispatchError, cachedFetchGet } from '../utils/fetch';
import { format } from 'date-fns';
import { parseISOLocal } from '../utils/date';

function getPackagesRequest(day) {
  return {
    type: GET_PACKAGES_REQUEST,
    day
  };
}

function getPackagesFailure(day, error, errors) {
  return {
    type: GET_PACKAGES_FAILURE,
    day,
    error,
    errors
  };
}

function getPackagesSuccess(day, packages) {
  return {
    type: GET_PACKAGES_SUCCESS,
    day,
    packages,
    date: new Date(),
    timeout: setTimeout(getPackagesTimeout, 5000)
  };
}

function getPackagesTimeout() {
  return {
    type: GET_PACKAGES_TIMEOUT
  };
}

export default function getPackages() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const {
        config,
        sale: {
          sale: { day, promoCode }
        },
        inventory: { cacheBust }
      } = getState();

      dispatch(getPackagesRequest(day));

      const date = parseISOLocal(day);
      const dateString = format(date, 'yyyyMMdd');

      // https://tickets-api-local.com:5001/api/items?startDate=08282019&startTime=000000&endDate=08282019&endTime=110000
      cachedFetchGet(config, 'items', {
        startDate: dateString,
        startTime: '000000',
        endDate: dateString,
        endTime: '235959',
        // admissions: true,
        mktgcode: promoCode,
        cacheBust: cacheBust,
        headNode:
          config.headNode == null || config.headNode.trim() == ''
            ? null
            : config.headNode
      })
        .then(packages => {
          dispatch(getPackagesSuccess(day, packages));
          resolve();
        })
        .catch((...args) => {
          dispatchError(dispatch, getPackagesFailure.bind(this, day))(...args);
          reject(...args);
        });
    });
}
